import TextUtil from "../../../../../shared/lib/html5-software-library/src/ranj/components/text/TextUtil";
import LayoutManager from "../../../../../shared/lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractPopupMediator from "../../../../../shared/src/ranj/app/ui/AbstractPopupMediator";
import RichTextWrapper from "../../../../../shared/src/ranj/app/ui/richtext/RichTextWrapper";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";
import ProgressDotsView from "./ProgressDotsView";

export default class TutorialOverlayMediator extends AbstractPopupMediator {

    /**
     * 
     * @param {createjs.MovieClip} target 
     * @param {somajs.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {LayoutManager} layoutManager 
     * @param {GameConfig} gameConfig 
     * @param {AppModel} appModel
     */
    constructor(target, dispatcher, languagePack, layoutManager, gameConfig, appModel) {
        super(target, dispatcher, languagePack, layoutManager);
        this._gameConfig = gameConfig;
        this._appModel = appModel;
    }


    initialize() {
        super.initialize();

        this.registerEventListener(GameModel.CLOSE_TUTORIAL_POPUP, this.close.bind(this));

        this._bgs = [];
        this._gameMockups = [];
        this._lines = [];
        let n;
        const localizations = this._gameConfig.getValue("tutorial.localization");
        
        for (n = 0; n < 99; n++) {
            const f = n + 1;
            const bg = this._target["bg" + f];
            if (!bg) {
                break;
            }
            this._bgs.push(bg);
            this._gameMockups.push(this._target["game" + f]);

            //block clicks through panel, quick and dirty
            bg.addEventListener("click", () => { });            

            //Apply custom/extra localizations:
            const localizationMap = localizations[n];
            for (const key in localizationMap) {
                const { id, richText, centerVertically} = localizationMap[key];
                const text = this.getText(id);
                let elem = getElement(this._target, key.split("."));
                if (richText) {
                    const panel = elem.parent;
                    elem = new RichTextWrapper(elem);
                    elem.text = text;
                    if (centerVertically) {
                        this.centerVertically(elem, panel);
                    }
                } else {
                    if (centerVertically) {
                        const initialHeight = elem.getMeasuredHeight();    
                        elem.text = text;
                        TextUtil.centerTextVertically(elem, initialHeight);
                    } else {
                        elem.text = text;
                    }
                }
            }
        }

        this._numPages = n;
        
        this._progressView = new ProgressDotsView(this._target.progressDots, n, this._appModel?.rtl ?? false);

        this.applyText(this._target.bodyTextfield, "", false);
        this._bodyRichText = new RichTextWrapper(this._target.bodyTextfield);

        this._buttonNext = this.createButton(this._target.nextButton, this._handleNext.bind(this), this.getText("tutorial.buttonNext"));
        this._buttonPrev = this.createButton(this._target.prevButton, this._handlePrev.bind(this), this.getText("tutorial.buttonPrev"));
        this._buttonStart = this.createButton(this._target.button, this._handleNext.bind(this), this.getText("tutorial.buttonStart"));
        this._setPage(0);

        if (ranj.DEBUG) {
            this._handleKeyUp = this._handleKeyUp.bind(this);
            window.document.addEventListener('keyup', this._handleKeyUp);
        }
    }

    destroy() {
        super.destroy();
        this.unregisterEventListener(GameModel.CLOSE_TUTORIAL_POPUP, this.close.bind(this));
        if (ranj.DEBUG) {
            window.document.removeEventListener('keyup', this._handleKeyUp);
        }
    }

    _handleKeyUp(e) {
        const c = String.fromCharCode(e.which);
        if (c == "X") this._changePage(99);
    }

    _handleNext() {
        this._changePage(1);
    }
    _handlePrev() {
        this._changePage(-1);
    }


    _changePage(delta) {
        const f = Math.max(0, this._pageIdx + delta);
        const n = this._numPages;
        if (f >= n) {
            this._buttonPrev.setEnabled(false);
            this._buttonNext.setEnabled(false);
            this._buttonStart.setEnabled(false);
            this.dispatch(GameModel.TUTORIAL_SEEN);
        } else {
            this._target.gotoAndStop(f);
            const duration = this._gameConfig.getValue("tutorial.crossFadeDuration");
            const wait = this._gameConfig.getValue("tutorial.crossFadeDelay");
            createjs.Tween.get(this._target)
                .to({ alpha: 0 }, duration, createjs.Ease.quadOut)
                .call(() => {
                    this._setPage(f);
                })
                .wait(wait)
                .to({ alpha: 1 }, duration, createjs.Ease.quadIn);
        }
    }

    _setPage(idx) {
        this._pageIdx = idx;
        const n = this._numPages;
        this._buttonPrev.setEnabled(idx > 0);
        this._buttonNext.setEnabled(idx < n - 1);
        this._buttonNext.setVisible(idx < n - 1);
        this._buttonStart.setVisible(idx == n - 1);
        this._progressView.setProgress(idx);

        const prefix = "tutorial.overlay" + (idx + 1) + ".";
        // this._target.bodyTextfield.text = this.getText(prefix + "body");
        this._bodyRichText.text = this.getText(prefix + "body");
        this.applyText(this._target.titleTextfield, this.getText(prefix + "title"));

        this._bgs.forEach((bg, i) => { bg.visible = i == idx; });
        this._gameMockups.forEach((elem, i) => { elem.visible = i == idx; });
        this._lines.forEach((lines, i) => { lines.visible = i == idx; });
    }

};

const getElement = (target, path) => {
    if (path.length > 1) {
        const head = path.shift()
        return getElement(target[head], path);
    } else {
        return target[path];
    }
}